// iter372 pt 2 (modèle D3) — séparateur entre onglets O2 : 1 × 20 px, dégradé transparent → #34343c → transparent, 16 px de chaque côté.
export const TabSeparator = ({ testid }) => (
  <span aria-hidden="true" data-testid={testid || "tab-separator"} style={{ width: 1, height: 20, margin: "0 16px", alignSelf: "center", flexShrink: 0, background: "linear-gradient(to bottom, transparent, #34343c, transparent)" }} />
);
